<template>
  <div>
    <component
      :is="slideoverComponent"
      :title="slideoverTitle"
      :visible="slideoverVisible"
      v-bind="slideoverProperties"
      @toggle-slideover="toggleSlideover"
      @update-discounts="getDiscounts"
    />
    <div class="pb-3 flex flex-row justify-end" style="height: 40px">
      <ActionsMenu>
        <ActionsItem
          :disabled="!canSendEmail"
          @click="
            toggleSlideover('CustomerEmailDiscount', 'Email Discount', {
              discount: selectedItem,
            })
          "
        >
          Email Discount
        </ActionsItem>
        <ActionsItem
          :disabled="!canSendEmail"
          @click="
            toggleSlideover('DeactivateDiscount', 'Deactivate Discount', {
              discount: selectedItem,
            })
          "
        >
          Deactivate Discount
        </ActionsItem>
      </ActionsMenu>
    </div>

    <div style="height: 600px">
      <ag-grid-vue
        style="width: 100%; height: 100%"
        class="ag-theme-balham"
        :columnDefs="columnDefs"
        :rowData="rowData"
        :paginationAutoPageSize="false"
        :paginationPageSize="paginationPageSize"
        :pagination="true"
        id="myGrid"
        :gridOptions="gridOptions"
        @grid-ready="onGridReady"
        :context="context"
        :frameworkComponents="frameworkComponents"
        :defaultColDef="defaultColDef"
        :enableCellTextSelection="true"
        :ensureDomOrder="true"
        :getRowHeight="getRowHeight"
        :rowSelection="rowSelection"
        :isRowSelectable="isRowSelectable"
      >
      </ag-grid-vue>
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import agGrid from "@/mixins/agGrid.js";
import { date } from "@/components/agGrid/cellRenderers";
import CustomerEmailDiscount from "@/views/Customers/components/slideovers/CustomerEmailDiscount.vue";
import DeactivateDiscount from "@/views/Customers/components/slideovers/DeactivateDiscount.vue";
import { ApiFactory } from "@/api/ApiFactory";

const CustomersAPI = ApiFactory.get("customers");

export default {
  name: "CustomerDiscounts",
  data() {
    return {
      columnDefs: null,
      paginationPageSize: 100,
      frameworkComponents: null,
      gridApi: null,
      columnApi: null,
      gridOptions: null,
      context: null,
      defaultColDef: null,
      overlayLoadingTemplate: true,
      fullWidthCellRenderer: null,
      isFullWidthCell: null,
      getRowHeight: null,
      rowSelection: null,
      isRowSelectable: null,
      selectedItem: {},
      slideoverTitle: "",
      slideoverVisible: false,
      slideoverComponent: null,
      slideoverProperties: {},
      shopifyDiscounts: null,
      rowData: null,
    };
  },
  props: {
    customer: {
      type: Object,
      default: null,
    },
  },
  components: {
    AgGridVue,
    CustomerEmailDiscount,
    DeactivateDiscount,
  },
  mixins: [agGrid],
  methods: {
    onGridReady() {},
    itemSelectionChanged() {
      let rows = this.gridOptions.api.getSelectedRows();
      if (rows.length !== 1) {
        this.selectedItem = {};
        return;
      }
      this.selectedItem = rows[0];
    },
    toggleSlideover(component, title, properties) {
      if (component) {
        this.slideoverComponent = component;
        this.slideoverTitle = title;
        this.slideoverProperties = properties || {};
      }

      setTimeout(() => {
        this.slideoverVisible = !this.slideoverVisible;
      }, 3);
    },
    getDiscounts() {
      this.gridOptions?.api?.showLoadingOverlay();
      this.rowData = null;
      CustomersAPI.getShopifyDiscounts(this.customer.CustomerID).then(
        (response) => {
          this.rowData = response.data.body;
          this.$emit("discounts", this.rowData);
        },
      );
    },
  },
  beforeMount() {
    this.gridOptions = {
      onSelectionChanged: this.itemSelectionChanged,
    };
    this.context = { componentParent: this };
    this.rowSelection = "single";

    this.defaultColDef = {
      sortable: true,
      filter: true,
      flex: 1,
      suppressMovable: true,
    };

    this.isFullWidthCell = (rowNode) => {
      return rowNode.data.fullWidth;
    };

    this.isRowSelectable = (rowNode) => {
      return !rowNode.data.fullWidth;
    };

    this.columnDefs = [
      {
        headerName: "Id",
        field: "id",
        filter: "agNumberColumnFilter",
      },
      {
        headerName: "Site",
        field: "store_front",
      },
      {
        headerName: "Discount Id",
        field: "shopify_discount_id",
        filter: "agNumberColumnFilter",
      },
      {
        headerName: "Discount Code",
        flex: 2,
        field: "shopify_discount_code",
      },
      {
        headerName: "Status",
        field: "active",
        cellRenderer: (params) => (params.data.active ? "Active" : "Inactive"),
        valueGetter: (params) => (params.data.active ? "Active" : "Inactive"),
        filterParams: this.customFilter({
          options: ["Active", "Inactive"],
        }),
      },
      {
        headerName: "Amount Issued",
        field: "total_amount",
        cellRenderer: (params) => `$${Number(params?.data?.total_amount).toFixed(2)}`,
        filter: "agNumberColumnFilter",
        type: "rightAligned",
      },
      {
        headerName: "Amount Used",
        field: "amount_used",
        cellRenderer: (params) => `$${Number(params?.data?.amount_used).toFixed(2)}`,
        filter: "agNumberColumnFilter",
        type: "rightAligned",
      },
    ];

    this.frameworkComponents = {
      dateCell: date,
    };
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
  },
  created() {
    this.getDiscounts();
  },
  computed: {
    canSendEmail() {
      return this.selectedItem?.active;
    },
  },
};
</script>

<style lang="scss">
@import "../../../../node_modules/ag-grid-community/dist/styles/ag-grid.css";
@import "../../../../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";

.ag-header-cell-label .ag-header-cell-text {
  white-space: normal !important;
  text-align: center;
}
.ag-theme-balham .ag-row:hover {
  background-color: #def7ec !important;
  color: black;
}
.ag-theme-balham .ag-row-selected {
  background-color: #bcf0da !important;
  color: black;
}
</style>
